import { useEffect, useRef, useState } from 'react';
import type { TaskRecord } from '../../tasks-table/tasks-table.type';
import { TaskDetail } from './task-detail';
import { TaskList } from './task-list';

type TaskSideSectionProps = {
  tasks: TaskRecord[];
  categoryTitle: string;
  onClose: () => void;
  isLoading?: boolean;
  onExpandTaskDetails?: () => void;
  selectedMeasure?: string | null;
  selectedMeasureFilter?: string | null;
};

const TaskSideSection = ({
  tasks,
  categoryTitle,
  onClose,
  isLoading = false,
  onExpandTaskDetails,
  selectedMeasure,
  selectedMeasureFilter,
}: TaskSideSectionProps) => {
  const [selectedTask, setSelectedTask] = useState<TaskRecord | null>(null);
  const prevSelectedMeasureRef = useRef<string | null>(selectedMeasure);
  const prevSelectedMeasureFilterRef = useRef<string | null>(selectedMeasureFilter);

  useEffect(() => {
    const measureChanged = prevSelectedMeasureRef.current !== selectedMeasure;
    const measureFilterChanged = prevSelectedMeasureFilterRef.current !== selectedMeasureFilter;

    if (measureChanged || measureFilterChanged) {
      setSelectedTask(null);
      prevSelectedMeasureRef.current = selectedMeasure;
      prevSelectedMeasureFilterRef.current = selectedMeasureFilter;
    }
  }, [selectedMeasure, selectedMeasureFilter]);

  const handleSelectTask = (task: TaskRecord) => {
    setSelectedTask(task);
  };

  const handleBackToList = () => {
    setSelectedTask(null);
  };

  if (selectedTask) {
    return <TaskDetail task={selectedTask} onClose={onClose} onBack={handleBackToList} />;
  }

  return (
    <TaskList
      tasks={tasks}
      title={categoryTitle}
      onSelectTask={handleSelectTask}
      onClose={onClose}
      isLoading={isLoading}
      onExpandTaskDetails={onExpandTaskDetails}
    />
  );
};

export { TaskSideSection };
